import { createRoute, redirect } from '@tanstack/react-router'

import { isUuid } from '@/lib/entity'
import { appRoute } from './app-route'

export const entityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '$entityId',
  beforeLoad: ({ params }) => {
    if (!isUuid(params.entityId)) {
      throw redirect({ to: '/' })
    }
  },
})
